module.exports = __webpack_public_path__ + "img/移动3.d9fffcf9.svg";